var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.length > 0)?_c('v-btn',{staticClass:"hvh-btn hvh-btn--primary m-1",attrs:{"flat":""},on:{"click":_vm.exportToExcel}},[_vm._v("Export to Excel")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }